import { type IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMemo } from 'react';
import './index.css';

interface SCBannerProps {
  Text: string;
  Colour?: 'blue' | 'green' | 'red' | 'orange';
  Visible?: boolean;
  Icon?: IconDefinition;
}

function SCBanner(props: SCBannerProps) {
  const className = useMemo(() => {
    let className = 'sc-banner-base ';
    switch (props.Colour) {
      case 'blue': {
        className += 'sc-banner-blue';
        break;
      }
      case 'green': {
        className += 'sc-banner-green';
        break;
      }
      case 'red': {
        className += 'sc-banner-red';
        break;
      }
      case 'orange': {
        className += 'sc-banner-orange';
        break;
      }
      default: {
        className += 'sc-banner-blue';
        break;
      }
    }
    return className;
  }, [props.Colour]);

  if (props.Visible == false) return null;

  return (
    <div className={className}>
      {props.Icon && <FontAwesomeIcon icon={props.Icon} />}
      <p>{props.Text}</p>
    </div>
  );
}

export { SCBanner };
